<template>
  <div class="home-page">
    <banner></banner> <functional></functional> <service></service>
    <process></process>
  </div>
</template>

<script>
import banner from "@/components/views/home/banner.vue";
import functional from "@/components/views/home/functional.vue";
import service from "@/components/views/home/service.vue";
import process from "@/components/views/home/process.vue";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  components: {
    banner,
    functional,
    service,
    process
  }
};
</script>

<style lang="less">
.home-page {
  font-family: PingFangSC-Medium;
}
</style>
